<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <b-row class="no-gutters">
        <b-col>
          <h1 class="mr-sm-4 header-tablepage">RICH MENU DETAIL</h1>
        </b-col>
      </b-row>

      <b-tabs v-model="tabIndex">
        <b-tab title="Set up">
          <div class="bg-white">
            <div class="title-tabs">
              <b-row calss="">
                <b-col md="6" class="text-left d-flex">
                  <div>General Information</div>
                </b-col>
              </b-row>
            </div>
            <div class="p-3">
              <b-row>
                <b-col>
                  <b-form-checkbox
                    :id="`checkbox-default`"
                    :name="`checkbox-default`"
                    v-model="form.isDefault"
                  >
                    Default
                  </b-form-checkbox>
                </b-col>
                <div class="break-normal"></div>
                <b-col md="6">
                  <InputText
                    v-model="form.name"
                    isRequired
                    textFloat="Name"
                    placeholder="Name"
                    type="text"
                    :isValidate="$v.form.name.$error"
                    :v="$v.form.name"
                    :disabled="id != 0"
                  />
                </b-col>
                <b-col md="6">
                  <InputText
                    v-model="form.richMenuAlias"
                    textFloat="Alias"
                    placeholder="Alias"
                    type="text"
                    :isValidate="$v.form.richMenuAlias.$error"
                    :v="$v.form.richMenuAlias"
                    :disabled="id != 0"
                  />
                </b-col>
              </b-row>
            </div>

            <Template ref="template" :data="form" :id="id"></Template>
          </div>
          <div class="no-gutters bg-white mt-3 py-2 px-3">
            <b-form-checkbox
              switch
              v-model="form.status"
              class="radio-active"
              size="lg"
            >
              <span class="ml-2 main-label">{{
                form.status ? "Active" : "Inactive"
              }}</span>
            </b-form-checkbox>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <FooterAction routePath="/setting/rich-menu/list" @submit="checkSubmit()" />
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import InputText from "@/components/inputs/InputText.vue";
import Template from "./components/Template.vue";
import { required } from "vuelidate/lib/validators";
const eng_lower_number = (val) => {
  if (!val) return true;
  if (val.match("^[a-z0-9\s-]+$")) {
    return true;
  }
  return false;
};
export default {
  components: {
    OtherLoading,
    InputText,
    Template,
  },

  data() {
    return {
      isLoading: true,
      form: {
        name: "",
        richMenuAlias: "",
        isDefault: false,
        status: true,
      },
      id: this.$route.params.id,
      tabIndex: 0,
      templateOptions: [{ text: "3*2", value: "3*2" }],
    };
  },
  validations() {
    return {
      form: {
        name: {
          required,
        },
        richMenuAlias: {
          eng_lower_number,
        },
      },
    };
  },
  async created() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      this.isLoading = true;
      if (this.id > 0) {
        const res = await this.axios(`/lineRich/${this.id}`);
        if (res.data.result == 1) {
          this.form = res.data.detail;
        }
      }

      this.isLoading = false;
    },
    async saveForm() {
      this.$refs.template.$v.$touch();
      this.$v.form.$touch();
      if (this.$refs.template.$v.$error || this.$v.form.$error) return;
      this.isLoading = true;
      let payload = {
        ...this.$refs.template.form,
        ...this.form,
        chatBarText: this.$refs.template.form.chatBarText,
      };
      const res = await this.axios.post(`/lineRich/CreateRichMenu`, payload);
      if (res.data.result == 1) {
        this.successAlert().then(() => this.$router.push("/setting/rich-menu"));
      } else {
        this.errorAlert(res.data.message);
      }

      this.isLoading = false;
    },
    async saveDefault() {
      this.isLoading = true;
      const res = await this.axios.put(
        `linerich/edit/${this.$route.params.id}/${
          this.form.isDefault ? 1 : 0
        }/${this.form.status ? 1 : 0}`
      );
      if (res.data.result == 1) {
        this.successAlert().then(() => this.$router.push("/setting/rich-menu"));
      } else {
        this.errorAlert(res.data.message);
      }
      this.isLoading = false;
    },
    checkSubmit() {
      if (this.id != 0) this.saveDefault();
      else this.saveForm();
    },
  },
};
</script>

<style lang="scss" scoped>
.text-link {
  text-decoration: underline;
}
</style>
